import React, { useEffect, useMemo, useState } from "react";
import { useDispatch } from "react-redux";
import {
  NavigateFunction,
  useLocation,
  useNavigate,
  useParams,
} from "react-router-dom";

import { Box, Button, Typography } from "@mui/material";
import { routeName } from "../../../routes/routeName";
import StepperCustom from "../../../components/step/Stepper";
import { useTranslation } from "react-i18next";
import {
  ButtonOutlined,
  ButtonPrimary,
} from "../../../components/button/ButtonCustoms";
import { MeetingRoomApi } from "../../../api/meeting-room/meeting-room.api";
import {
  alertError,
  alertSuccess,
  swalError,
} from "../../../components/alert/swal";
import NavigateListCustom from "../../../components/navigation/NavigationListCustom";
import { setLoading, unsetLoading } from "../../../store/loading/loading.slice";
import MeetingRoomDetail from "./components/MeetingRoomDetail";
import MeetingRoomForm from "./components/MeetingRoomForm";
import { BookingMeetingRoomApi } from "../../../api/booking-meeting-room/booking-meeting-room.api";
import OtherDetail from "../../home/classroom-meeting-booking/element/OtherDetail";
import { useManageStateDetail } from "../../home/classroom-meeting-booking/manageStateDetail";
import ModalCustom from "../../../components/modal/modalCustomCms";
import InputTextField from "../../../components/input/inputTextField";
import { BOOKING_MEETING_APPROVE, BOOKING_MEETING_ROOM, booking_meeting_room_status } from "../../home/classroom-meeting-booking/enum";
import ArticleIcon from '@mui/icons-material/Article';
import PanoramaHorizontalIcon from '@mui/icons-material/PanoramaHorizontal';
import ReceiptIcon from '@mui/icons-material/Receipt';
import ItemsDetail from "../../home/classroom-meeting-booking/element/ItemsDetail";
import RoomMeetingService from "../booking-room-management/components/RoomMeetingService";
import PaymentBookingMeetingRoom from "../../home/classroom-meeting-booking/element/PaymentBookingMeetingRoom";
import { BankAccountTypeOptions } from "../course-online/manage-payment-channel/enum/manage_payment";
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import StatusCustom from "../../../components/status/statusCustom";
import CheckBoxOutlinedIcon from '@mui/icons-material/CheckBoxOutlined';
import DateRangeOutlinedIcon from '@mui/icons-material/DateRangeOutlined';
import MeetingRoomContact from "../../home/classroom-meeting-booking/element/MeetingRoomContact";
import CalendarActivityDetail from "../../home/classroom-meeting-booking/element/CalendarActivityDetail";
// import RoomMeetingDevice from "./components/RoomMeetingDevice";


const BookingRoomDetail = ({ view, title, is_request, sub_title, path_list }: {
  view: boolean,
  title?: string,
  sub_title?: string,
  is_request?: boolean,
  path_list?: string;
}) => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const mode = queryParams.get("mode");
  const pathname = location.pathname;

  const { id } = useParams();

  const navigate: NavigateFunction = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const defaultStateFormMeetingRoom = {
    id_meeting_type: "",
    id_meeting_room: "",
    id_room_meeting: "",
    meeting_room_name: "",
    meeting_room_desc: "",
    meeting_room_limit_person: 0,
    meeting_room_start_date: "",
    meeting_room_end_date: "",
    meeting_room_start_time: "",
    meeting_room_end_time: "",
    meeting_room_location: "",
    meeting_room_internal_service_fees: 0,
    meeting_room_external_service_fees: 0,
    status: "",
  };
  const [formMeetingRoom, setFormMeetingRoom] = useState<any>(
    defaultStateFormMeetingRoom
  );

  const [room_meeting_type, set_room_meeting_type] = useState<string>("");
  const [meeting_room_status, set_meeting_room_status] = useState<string>("");
  const [step, setStep] = useState<number>(0);
  const [notEdit, setNotEdit] = useState<boolean>(true);
  const [dataDeviceByRoomMeeting, setDataDeviceByRoomMeeting] = useState<any[]>(
    []
  );
  const [dataServiceByRoomMeeting, setDataServiceByRoomMeeting] = useState<any>(
    {}
  );
  const [roomMeetinDetail, setRoomMeetinDetail] = useState<any>({});


  const getDetail = async (id_meeting_room: number) => {
    try {
      const res = await BookingMeetingRoomApi.getMeetingRoomDetailById(
        id_meeting_room
      );


      if (res.status < 300) {
        const meeting_room = res?.data?.data?.meeting_room;
        set_room_meeting_type(meeting_room?.room_meeting_master?.room_meeting_type || "");
        set_meeting_room_status(meeting_room?.meeting_room_status || "")
        // console.log(res?.data?.data?.room_meeting_master?.room_meeting_type,'res?.data?.data?.room_meeting_master?.room_meeting_type')
        getRoomMeetingDetail(
          res.data.data?.meeting_room?.id_room_meeting,
          res.data.data.meeting_room
        );

        setDataDeviceByRoomMeeting(
          res.data.data?.meeting_room?.equipment ?? []
        );

        setDataServiceByRoomMeeting(
          res.data.data?.meeting_room?.services ?? []
        );
      }
    } catch (error) {
      console.log(error);
      swalError(t("เกิดข้อผิดพลาด"));
    }
  };


  useEffect(() => {
    if (id) {
      getDetail(+id);
    }
  }, [id]);

  const handleSave = async (
    body?: any,
    id_meeting_room?: number | null,
    status?: string,
    is_alert?: boolean
  ) => {
    const title = t("เพิ่มข้อมูลอุปกรณ์ภายในห้อง");

    dispatch(setLoading());

    const payload = {
      id_meeting_type: 0,
      meeting_room_name: body.meeting_room_name,
      meeting_room_start_date: body.meeting_room_start_date,
      meeting_room_end_date: body.meeting_room_end_date,
      meeting_room_start_time: body.meeting_room_start_time,
      meeting_room_end_time: body.meeting_room_end_time,
      meeting_room_desc: body.meeting_room_desc,
      id_room_meeting: body.id_room_meeting,
      is_meeting_online: 0,
      is_internal_person: 1,
      status: status,
      is_content: body?.is_content,
      id_content: body?.id_content
    };

    try {
      let response: any = null;

      if (id_meeting_room) {
        response = await BookingMeetingRoomApi.updateMeetingRoomByTypeList(
          +id_meeting_room,
          payload
        );
      } else {
        response = await BookingMeetingRoomApi.createMeetingRoomByTypeList(
          payload
        );
      }

      if (response.status < 300) {
        if (is_alert) {
          getDetail(id ? +id : response?.data.data?.id_meeting_room);
          alertSuccess(title, t("เพิ่มข้อมูลอุปกรณ์ภายในห้อง สำเร็จ"), undefined, () => {
            navigate(
              routeName.cms.BookingRoom +
              `/${response.data?.data?.id_meeting_room ?? id_meeting_room
              }/update?mode=update`
            );
          });
        } else {
          getDetail(id ? +id : response?.data.data?.id_meeting_room);
          navigate(
            routeName.cms.BookingRoom +
            `/${response.data?.data?.id_meeting_room ?? id_meeting_room
            }/update?mode=update`
          );
        }
      }
    } catch (err: any) {
      alertError(title, err?.response?.data?.message || t("เพิ่มข้อมูลอุปกรณ์ภายในห้อง ไม่สำเร็จ"));
    } finally {
      dispatch(unsetLoading());
    }
  };

  const getRoomMeetingDetail = async (
    id_meeting_room: number,
    meetinRoom: any
  ) => {
    try {
      const res = await MeetingRoomApi.findById(
        id_meeting_room
      );

      if (res.status < 300) {
        setRoomMeetinDetail(res.data.data);

        setFormMeetingRoom({
          id_meeting_room: meetinRoom?.id_meeting_room,
          id_meeting_type: res.data.data?.room_meeting_type ?? "",
          id_room_meeting: meetinRoom?.id_room_meeting,
          meeting_room_name: meetinRoom?.meeting_room_name,
          meeting_room_desc: meetinRoom?.meeting_room_desc,
          meeting_room_limit_person: meetinRoom?.meeting_room_amount,
          meeting_room_start_date: meetinRoom?.meeting_room_start_date,
          meeting_room_end_date: meetinRoom?.meeting_room_end_date,
          meeting_room_start_time: meetinRoom?.meeting_room_start_time,
          meeting_room_end_time: meetinRoom?.meeting_room_end_time,
          meeting_room_location: meetinRoom?.meeting_room_location,
          meeting_room_internal_service_fees: meetinRoom?.internal_service_fees,
          meeting_room_external_service_fees: meetinRoom?.external_service_fees,
          id_content: meetinRoom?.id_content,
          is_content: meetinRoom?.is_content,
          status: meetinRoom?.status,
        });
      }
    } catch (error) {
      console.log(error);
      swalError(t("เกิดข้อผิดพลาด"));
    }
  };

  // const handleApprove = async (id_meeting_room: number, status: string) => {
  //   if (id_meeting_room) {
  //     const titleApprove = "อนุมัติการจองห้องเรียน/ห้องประชุม";
  //     const subTitleApprove =
  //       "ท่านต้องการอนุมัติการจองห้องเรียน/ห้องประชุม ใช่หรือไม่";
  //     const titleReject = "ปฏิเสธการจองห้องเรียน/ห้องประชุม";
  //     const subTitleReject =
  //       "ท่านต้องการปฏิเสธการจองห้องเรียน/ห้องประชุม ใช่หรือไม่";

  //     alertActive(
  //       status === "APPROVE" ? titleApprove : titleReject,
  //       status === "APPROVE" ? subTitleApprove : subTitleReject,
  //       undefined,
  //       undefined,
  //       async () => {
  //         dispatch(setLoading());
  //         await BookingMeetingRoomApproveApi.ApproveMeetingRoomByTypeList(
  //           +id_meeting_room,
  //           {
  //             meeting_room_approve_type: status,
  //             meeting_room_approve_remark: "",
  //           }
  //         )
  //           .then((res) => {
  //             if (res.status < 300) {
  //               alertSuccess(
  //                 status === "APPROVE"
  //                   ? "อนุมัติการจองห้องเรียน/ห้องประชุม สำเร็จ"
  //                   : "ปฏิเสธการจองห้องเรียน/ห้องประชุม สำเร็จ",
  //                 undefined,
  //                 undefined,
  //                 () => {
  //                   onFetch();
  //                 }
  //               );
  //             }
  //           })
  //           .catch(() => {
  //             alertError(
  //               status === "APPROVE"
  //                 ? "อนุมัติการจองห้องเรียน/ห้องประชุม ไม่สำเร็จ"
  //                 : "ปฏิเสธการจองห้องเรียน/ห้องประชุม ไม่สำเร็จ"
  //             );
  //           })
  //           .finally(() => {
  //             dispatch(unsetLoading());
  //           });
  //       }
  //     );
  //   }
  //   return;
  // };


  const {
    formState,
    setFormState,
    error_message,
    clearErrorMessage,
    handleDownloadFile,
    handleAcceptAndReject,
    meeting_room_approve_remark,
    set_meeting_room_approve_remark,
    show_modal_approve,
    handleCloseModalApproveAndReject,
    select_bank,
    payment_channel_data,

    handleChangeStatusBookingMeetingRoom,
    is_outside,
    handleWaiting,
    is_waiting,
    handleSubmitWaiting,
    uploadMultiFilePromise,


  } = useManageStateDetail({});


  const show_payment = [
    BOOKING_MEETING_ROOM.WAITING_CONFIRM_PAYMENT,
    BOOKING_MEETING_ROOM.REJECT_BOOKING,
    BOOKING_MEETING_ROOM.CONFIRM_BOOKING,
  ].includes(formState.meeting_room_status as BOOKING_MEETING_ROOM);
  const can_approve = [
    BOOKING_MEETING_ROOM.WAITING_CONFIRM_PAYMENT
  ].includes(formState.meeting_room_status as BOOKING_MEETING_ROOM);
  const show_status = [
    BOOKING_MEETING_ROOM.WAITING_TO_CONSIDER
  ].includes(formState.meeting_room_status as BOOKING_MEETING_ROOM);
  const show_contact = [
    BOOKING_MEETING_ROOM.CONFIRM_BOOKING,
  ].includes(formState.meeting_room_status as BOOKING_MEETING_ROOM);


  const allStep: any[] = useMemo(
    () => [
      { name: is_request ? t("ข้อมูลการจอง") : t("ข้อมูลห้อง"), isAccept: true, icon: <ArticleIcon />, disabled: !notEdit },
      ...(is_request ? [

      ] : [
        {
          name: t("ระบุข้อมูลเพิ่มเติม"),
          isAccept: true,
          icon: null,
          disabled: !notEdit,
        },
      ]),
      {
        name: is_request ? t("ข้อมูลอุปกรณ์เพิ่มเติม") : t("ระบุอุปกรณ์เพิ่มเติม"),
        isAccept: true,
        icon: <PanoramaHorizontalIcon />,
        disabled: !notEdit,
      },
      {
        name: is_request ? t("บริการเพิ่มเติม") : t("ระบุบริการเพิ่มเติม"),
        isAccept: true,
        icon: <ReceiptIcon />,
        disabled: !notEdit,
      },
      ...(show_payment ? [
        {
          name: t("ข้อมูลการชำระเงิน"),
          isAccept: true,
          disabled: false,
          icon: <AccountBalanceWalletIcon />
        },
      ] : []),
      ...(show_contact ? [
        {
          name: t("รายละเอียดการอนุมัติ"),
          isAccept: true,
          disabled: false,
          icon: <CheckBoxOutlinedIcon />
        },
        {
          name: t("ข้อมูลในปฏิทินกิจกรรม"),
          isAccept: true,
          disabled: false,
          icon: <DateRangeOutlinedIcon />
        },
      ] : [])
    ],
    [t, show_payment]
  );
  return (
    <div className="h-auto">
      <Box className="flex justify-between items-center">
        <span>
          <NavigateListCustom
            navigateData={[
              {
                name: title ? t(title) : t("จองห้องเรียน/จองห้องประชุม"),
                key: "1",
                pathName: path_list || routeName.cms.BookingRoom,
              },
              {
                name: sub_title ? t(sub_title) : view
                  ? mode === "APPROVE"
                    ? t("อนุมัติการจองห้องเรียน/ห้องประชุม")
                    : mode === "APPROVE"
                      ? t("แก้ไขการจองห้องเรียน/ห้องประชุม")
                      : t("ข้อมูลการจองห้องเรียน/ห้องประชุม")
                  : t("ทำเรื่องขอจอง"),
                key: "2",
                pathName: pathname
              },
            ]}
          />
        </span>
        <span>
          {can_approve && (
            <div className="flex gap-4 justify-end">
              <Button onClick={() => handleChangeStatusBookingMeetingRoom(formMeetingRoom.id_meeting_room, BOOKING_MEETING_APPROVE.APPROVE, t('อนุมัติ', { context: "action" }), t('ต้องการอนุมัติหรือไม่?'))} variant="contained" color="success">{t("อนุมัติ", { context: "action" })}</Button>
              <Button onClick={() => handleWaiting()} variant="contained" color="secondary">{t("ส่งทบทวน", { context: "action" })}</Button>
              <Button onClick={() => handleAcceptAndReject(formMeetingRoom.id_meeting_room, true, undefined, () => {
                getDetail(formMeetingRoom.id_meeting_room)
              })} variant="contained" color="error">{t("ไม่อนุมัติ", { context: "action" })}</Button>
            </div>
          )}
        </span>
      </Box>
      {/* header */}
      <section className="my-4 flex items-center justify-between flex-wrap gap-4">
        <Typography variant="h3" className="whitespace-nowrap">
          {sub_title ? t(sub_title) : view
            ? mode === "APPROVE"
              ? t("อนุมัติการจองห้องเรียน/ห้องประชุม")
              : t("แก้ไขการจองห้องเรียน/ห้องประชุม")
            : t("ทำเรื่องขอจอง")}
        </Typography>




        <div className="flex gap-4 flex-wrap">
          {!is_request && (
            <ButtonOutlined
              onClick={() => {
                navigate(routeName.cms.BookingRoomRequestMangement);
              }}
              buttonName={t("ยกเลิก")}
              btnProps={{ width: "150px" }}
            />
          )}

          {meeting_room_status === BOOKING_MEETING_ROOM.WAITING_TO_CONSIDER && !view && (
            <>
              <Button
                variant="contained"
                color="success"
                onClick={() => {
                  handleAcceptAndReject(formMeetingRoom.id_meeting_room, undefined, undefined, () => {
                    getDetail(formMeetingRoom.id_meeting_room)
                  })
                  // handleApprove(formMeetingRoom.id_meeting_room, "APPROVE");
                }}
                startIcon={<CheckBoxOutlinedIcon />}
              >
                {is_outside ? t("แจ้งให้ดำเนินการชำระเงิน") : t("อนุมัติ", { context: "action" })}
              </Button>

              <ButtonPrimary
                onClick={() => {
                  handleAcceptAndReject(formMeetingRoom.id_meeting_room, true, undefined, () => {
                    getDetail(formMeetingRoom.id_meeting_room)
                  })
                  // handleApprove(formMeetingRoom.id_meeting_room, "REJECT");
                }}
                mode="cancel"
                buttonName={t("ปฏิเสธ")}
                btnProps={{ width: "150px" }}
              />
            </>
          )}
        </div>
      </section>

      {show_status && (
        <section className="flex justify-start items-center">
          <StatusCustom
            disableMaxWidth
            sx={{ width: 'fit-content', px: 2.5 }}
            text={t(booking_meeting_room_status?.find((x) => x.value == meeting_room_status)?.label || "")}
            type={booking_meeting_room_status?.find((x) => x.value == meeting_room_status)?.label || ""}
          />
        </section>
      )}

      <section className="flex items-center justify-center">
        <StepperCustom
          sx={{ maxWidth: "1200px" }}
          step={step}
          setStep={(num: number) => {
            setStep(num);
          }}
          stepLabel={allStep}
          view={is_request ? true : mode === "VIEW" ? true : false}
        />
      </section>
      {step === 0 && (
        <section className="w-full mt-10">
          <MeetingRoomDetail
            formMeetingRoom={formMeetingRoom}
            setFormMeetingRoom={setFormMeetingRoom}
            roomMeetinDetail={roomMeetinDetail}
            room_meeting_type={room_meeting_type}
          />

          {is_request && (
            <OtherDetail
              formState={formState}
              setFormState={setFormState}
              errorMessage={error_message}
              clearErrorMessage={clearErrorMessage}
              disabled={true}
              handleDownloadFile={handleDownloadFile}
              hidden_detail_send_request
            />
          )}
        </section>
      )}

      {step === 1 && !is_request && (
        <section className="w-full mt-10">
          <MeetingRoomForm
            formMeetingRoom={formMeetingRoom}
            setFormMeetingRoom={setFormMeetingRoom}
          />
        </section>
      )}

      {step === (is_request ? 1 : 2) && (
        <section className="w-full mt-10">
          {/* <MeetingRoomDevice
            dataDevice={dataDeviceByRoomMeeting}
            onGetData={onFetch}
            id_meeting_room={id ? Number(id) : 0}
            id_room_meeting={formMeetingRoom.id_room_meeting}
          /> */}
          <ItemsDetail
            view={is_request || view}
            id_room_meeting={formMeetingRoom.id_room_meeting}
            id_meeting_room={formMeetingRoom.id_meeting_room}
            is_personal={!is_outside}
          />
        </section>
      )}

      {step === (is_request ? 2 : 3) && (
        <section className="w-full mt-10">
          {/* <MeetingRoomService
            dataService={dataServiceByRoomMeeting}
            onGetData={onFetch}
            id_meeting_room={id ? Number(id) : 0}
            id_room_meeting={formMeetingRoom.id_room_meeting}
          /> */}

          <RoomMeetingService
            id_room_meeting={formMeetingRoom.id_room_meeting}
            id_meeting_room={formMeetingRoom.id_meeting_room}
            is_booking
            view={is_request || view}
            is_personal={!is_outside}
          />
        </section>
      )}


      {step === 3 && is_request && show_payment && (
        <PaymentBookingMeetingRoom
          id_meeting_room={formMeetingRoom.id_meeting_room}
          payment_icon_url={select_bank?.icon || ""}
          payment_name={payment_channel_data?.account_name_th || "-"}
          payment_name_en={payment_channel_data?.account_name_eng || "-"}
          payment_no={payment_channel_data?.account_no || "-"}
          disabled={true}
          hidden_button
          payment_type={t(BankAccountTypeOptions?.find((x) => x.value === payment_channel_data?.account_type)?.label || "-")}
        />
      )}

      {step === 4 && is_request && show_contact && (
        <MeetingRoomContact
          id_meeting_room={formMeetingRoom.id_meeting_room}
          uploadMultiFilePromise={uploadMultiFilePromise}
          handleDownloadFile={handleDownloadFile}
        />
      )}

      {step === 5 && is_request && (
        <CalendarActivityDetail
          id_meeting_room={formMeetingRoom.id_meeting_room}
          uploadMultiFilePromise={uploadMultiFilePromise}
          handleDownloadFile={handleDownloadFile}
        />
      )}








      {step === 0 && (
        <section className="col-span-12 flex items-center justify-center gap-4 my-4">
          <ButtonOutlined
            onClick={() => {
              navigate(-1);
            }}
            buttonName={t("ย้อนกลับ")}
            btnProps={{
              width: "150px",
            }}
          />
          <ButtonPrimary
            onClick={() => {
              setStep(1);
            }}
            mode="next"
            disabled={!formMeetingRoom.id_room_meeting}
            buttonName={t("ถัดไป")}
            btnProps={{
              width: "150px",
            }}
          />
        </section>
      )}
      {step >= 1 && step < 4 && (
        <section className="col-span-12 flex items-center justify-center gap-4 my-4">
          <ButtonOutlined
            onClick={() => {
              setStep(step - 1);
            }}
            buttonName={t("ย้อนกลับ")}
            btnProps={{
              width: "150px",
            }}
          />

          {!formMeetingRoom.status ||
            !id ||
            formMeetingRoom.status === "DRAFT" ? (
            <ButtonPrimary
              onClick={() => {
                if (id) {
                  handleSave(formMeetingRoom, +id, "DRAFT", true);
                } else {
                  handleSave(formMeetingRoom, null, "DRAFT", true);
                }
              }}
              mode="save"
              buttonName={t("บันทึกร่าง", { context: "action" })}
              btnProps={{
                width: "150px",
              }}
            />
          ) : null}

          {mode !== "APPROVE" ? (
            <>
              {step === 3 && (
                <ButtonPrimary
                  onClick={() => {
                    if (id) {
                      handleSave(formMeetingRoom, +id, "PENDING", true);
                    } else {
                      handleSave(formMeetingRoom, null, "PENDING", true);
                    }
                  }}
                  mode="next"
                  buttonName={t("ยืนยัน")}
                  btnProps={{
                    width: "150px",
                  }}
                />
              )}

              {step < 3 && (
                <ButtonPrimary
                  onClick={() => {
                    if (step === 1 && !id) {
                      handleSave(formMeetingRoom, null, "DRAFT", false);
                      setStep(step + 1);
                    } else {
                      setStep(step + 1);
                    }
                  }}
                  mode="next"
                  buttonName={t("ถัดไป")}
                  btnProps={{
                    width: "150px",
                  }}
                />
              )}
            </>
          ) : (
            step < 3 && (
              <ButtonPrimary
                onClick={() => {
                  setStep(step + 1);
                }}
                mode="next"
                buttonName={t("ถัดไป")}
                btnProps={{
                  width: "150px",
                }}
              />
            )
          )}
        </section>
      )}


      {(show_modal_approve || is_waiting) && <ModalCustom
        handleClose={handleCloseModalApproveAndReject}
        onClick={() => {
          if (is_waiting) {
            handleSubmitWaiting(formMeetingRoom.id_meeting_room, () => {
              navigate(routeName.cms.BookingRoomRequestMangement)
            })
          } else {
            handleAcceptAndReject(formMeetingRoom.id_meeting_room, true, true, () => {
              getDetail(formMeetingRoom.id_meeting_room)
            })
          }
        }}
        open
        title={is_waiting ? t("ส่งทบทวน", { context: "action" }) : t("ไม่อนุมัติคำร้องขอจอง")}
        scrollBody
        maxWidth="md"
        subTitle={t("กรุณาระบุหมายเหตุ")}
        disabledSubmitButton={!meeting_room_approve_remark}
        form={
          <Box py={2} className="w-full">
            <InputTextField
              placeholder={t("กรุณาระบุ")}
              heading={t("หมายเหตุ")}
              value={meeting_room_approve_remark}
              row={4}
              inputHeight={"auto"}
              multiline
              disablePaddingMultiline
              onChange={(e) => set_meeting_room_approve_remark(e.target.value)}
            />
          </Box>
        }
      />}
    </div>
  );
};

export default BookingRoomDetail;
